// removed by extract-text-webpack-plugin
module.exports = {"feedbackHeader":"zS051v6HRA7kp2UTsII6J","compact":"_1KwdzpWiFwGKmVZuitpNQR","buttons":"_1bAKj1FpK1DjM9fCrPT6Pj","line":"_1pghOqS1X1-G3F6Mj4FE1Y","form":"PdCwb2XjWq88M2NAP7r-H","textArea":"eUpFF33S1nDsM9wD--BvR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/FeedbackForm/FeedbackForm.scss
// module id = 1287
// module chunks = 1